import {
  Box,
  Text,
  WizardStep,
  WizardStepRenderParams,
  useOnNext
} from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { EmployeeSelectorV2 } from 'modules/employees/components/EmployeeSelectorV2'
import { EmployeeSelectorV2MultiSelectState } from 'modules/employees/components/EmployeeSelectorV2/types'

import {
  WizardData,
  WizardDataField,
  validateMandatoryFields
} from 'modules/finance/lib/newBudgetWizard'

const BudgetAccessStep = ({ data, onDataChanged }: WizardStepRenderParams<WizardData>) => {
  const handleNext = async () => {
    const mandatoryFields: WizardDataField[] = ['ownerEmployeeIds']

    const { invalidFields, dataWithErrors } = validateMandatoryFields(mandatoryFields, data)

    onDataChanged(dataWithErrors)

    if (invalidFields.length) {
      return Promise.reject()
    }
  }

  const handleOwnerChange = (state: EmployeeSelectorV2MultiSelectState) => {
    // Extract ids from the multi-select state
    const ids = state.type === 'manual' ? state.ids : []
    onDataChanged({ ...data, ownerEmployeeIds: ids })
  }

  const handleViewerChange = (state: EmployeeSelectorV2MultiSelectState) => {
    // Extract ids from the multi-select state
    const ids = state.type === 'manual' ? state.ids : []
    onDataChanged({ ...data, viewerEmployeeIds: ids })
  }

  useOnNext(handleNext)

  return (
    <Box gap="s40" flexDirection="column">
      <Box gap="s24" width="full">
        <Box gap="s8">
          <Text.Header2>{i18n.t('budgets.forms.new_budget.budget_access.title')}</Text.Header2>

          <Text.Normal>{i18n.t('budgets.forms.new_budget.budget_access.description')}</Text.Normal>
        </Box>
      </Box>
      <Box gap="s24" maxWidth="s600" flexDirection="column">
        <Box gap="s8" flexDirection="column">
          <EmployeeSelectorV2
            multiple
            mandatory
            label={i18n.t('budgets.forms.new_budget.budget_access.budget_owners')}
            hint={i18n.t('budgets.forms.new_budget.budget_access.budget_owners_description')}
            value={data.ownerEmployeeIds}
            onChange={handleOwnerChange}
            error={data.errors?.ownerEmployeeIds}
            options={{ disableSelectAll: true }}
          />
        </Box>

        <Box gap="s8" flexDirection="column">
          <EmployeeSelectorV2
            multiple
            label={i18n.t('budgets.forms.new_budget.budget_access.budget_viewers')}
            hint={i18n.t('budgets.forms.new_budget.budget_access.budget_viewers_description')}
            value={data.viewerEmployeeIds}
            onChange={handleViewerChange}
            error={data.errors?.viewerEmployeeIds}
            options={{ disableSelectAll: true }}
          />
        </Box>
      </Box>
    </Box>
  )
}

export const budgetAccessStep = (): WizardStep<WizardData> => ({
  title: i18n.t('budgets.forms.new_budget.budget_access.title'),
  nextText: i18n.t('common.next'),
  render: (props) => <BudgetAccessStep {...props} />,
  isCompleted: () => true
})
